<template>
    <span :id="'wmarker_' + name"></span>
</template>

<script>
export default {
    name: 'w-marker',
    props: ['name', 'options', 'pane', 'zoom'],
    data: function() {
        return {
            marker_ID_prefix: this.pane.wmarker_builder._idPrefix,
            count: 0,
            has_jump_ctrl: this.options.zoom_ctrl && this.options.zoom_ctrl.jump,
            has_show_ctrl: this.options.zoom_ctrl && this.options.zoom_ctrl.show,
        }
    },
    computed: {
        list: function() {
            return this.options.list
        },
        column_map: function() {
            return this.options.wmarker_map
        },
        normal_zoom_class: function() {
            return $.map(this.options.zoom_ctrl.jump, (i, class_name) => {
                return class_name
            }).pop()
        },
        show_name: function() {
            if (!this.has_show_ctrl) {
                return true
            }

            if (!this.options.zoom_ctrl.show.name) {
                return true
            }

            if (this.zoom >= this.options.zoom_ctrl.show.name) {
                return true
            }

            return false
        },
        show_params: function() {
            if (!this.has_show_ctrl) {
                return true
            }

            if (!this.options.zoom_ctrl.show.params) {
                return true
            }

            if (this.zoom >= this.options.zoom_ctrl.show.params) {
                return true
            }

            return false
        },
    },
    mounted: function() {
        this.set_wmarker_style()

        $.map(this.list, (wmarker) => {
            this.create(wmarker)
        })

        this.pane.wmarker_builder.displayName(this.show_name)
        this.pane.wmarker_builder.displayBlockText(this.show_params)
        this.set_scale(this.options.scale)

        if (this.options.callback) {
            this.options.callback()
        }
    },

    methods: {
        set_wmarker_style: function() {
            if (this.options.show_wm_dir) {
                return
            }
            this.pane.wmarker_builder.setWindZeroStyle(1) //無風向標
        },
        create: function(data) {
            const latlng = data.latlng
            const properties = data.feature.properties
            const columns = this.column_map
            const ID = this.get_ID(properties[columns.id]) //站點ID
            const name = properties[columns.name] || '' //站點顯示名稱
            // 方向及速度皆為0時會以圓點呈現, 需搭配setWindZeroStyle使用
            const spd = this.options.show_wm_dir ? properties[columns.spd] : 0
            const dir = this.options.show_wm_dir ? properties[columns.dir] : 0

            // 九宮格顯示數值陣列
            const val_map = columns.val_map
            let val_list = $.map(val_map, (key) => {
                // 在地面氣象站產品中，若有測站的'HUMD', 'TEMP', 'PRES'資料都是 null，則用 '--' 代替 null
                // 這樣 popup table 才打得開
                if (['HUMD', 'TEMP', 'PRES'].includes(key) && properties[key] == null) {
                    properties[key] = '--';
                }

                return properties[key] || [null]
            })

            // [5][6][7] 九宮格數值分布
            // [3][X][4]
            // [0][1][2]

            if (this.options.val_format) {
                val_list = this.options.val_format(val_list)
            }

            const marker = new X.WindMarkerData(
                ID,
                name,
                latlng.lat,
                latlng.lng,
                val_list[0],
                val_list[1],
                val_list[2],
                val_list[3],
                val_list[4],
                val_list[5],
                val_list[6],
                val_list[7],
                spd,
                dir
            )
            this.add(ID, marker, data.feature['class-name'])

            // popup 資料
            if (this.options.popup) {
                // 新增一個 click evnet 事件
                const emit_popup_callback = this.options.emit_popup_callback
                if (emit_popup_callback) {
                    this.transmit_popup_data(
                        {
                            id: ID, 
                            feature: data.feature,
                            popup: this.options.popup
                        }, 
                        emit_popup_callback
                    )
                } else {
                    this.popup(ID, data.feature);
                }
            }

            // 更換顏色
            if (data.feature['marker-color']) {
                this.change_color(data.feature['marker-color'], ID)
            } else if (this.options.color) {
                this.change_color(this.options.color, ID)
            }
        },
        get_ID: function(assign_id) {
            //使用: 指定ID | 流水號
            const ID = '-' + this.name + '-' + (assign_id || this.count)
            this.count++

            return ID
        },
        add: function(ID, wmarker, class_name) {
            const wm_ID = '#' + this.marker_ID_prefix + ID

            this.pane.wmarker_builder.addLMarker(wmarker, this.pane, this.name)

            $(wm_ID)
                .addClass(this.get_wmarker_class())
                .parent()
                .appendTo(this.pane.$el)

            $(wm_ID)
                .parent()
                .addClass('gis-marker')

            if (class_name) {
                $(wm_ID).addClass(class_name)
            }
        },

        transmit_popup_data(options, emit_popup_callback) {
            const { id } = options
            this.pane.wmarker_builder
                .getLMarker(id)
                .on('click', () => emit_popup_callback(options));
        },

        popup: function(ID, feature) {
            const popup_html = this.get_popup_html(feature)

            this.pane.wmarker_builder.getLMarker(ID).bindPopup(popup_html)
        },
        get_popup_html: function(feature) {
            return `${this._create_table_data(feature)}${this._create_chart_botton(feature)}`
        },

        _create_table_data(feature) {
            const popup_data = this._get_popup_data(feature)

            let html = '<table class="popup-table striped">'
            $.each(popup_data, function(key, value) {
                html += '<tr><td>' + key + '</td><td>' + value + '</td></tr>'
            })
            html += '</table>'

            return html
        },

        _create_chart_botton(feature) {
            let html = ''
            if (feature.api_data) {
                html = `${html}<br>
                <input id="station_code" value="${feature.api_data.station_code}" type="hidden">
                <input id="data_time" value="${feature.api_data.data_time}" type="hidden">
                `
                if (feature.api_data?.type?.gauge) {
                    html = `${html}
                    <button class="open_gis_chart gis-btn teal white--text" chart_type="gauge">
                        ${this.$t('__gis.watch_rainfall_diagram_text')}
                    </button>
                    `;
                }
                if (feature.api_data?.type?.weather) {
                    html = `${html}
                    <button class="open_gis_chart gis-btn teal white--text" chart_type="weather">
                        ${this.$t('__gis.watch_weather_diagram_text')}
                    </button>
                    `
                }
            }

            return html
        },

        _get_popup_data: function(feature) {
            const api_data = feature.api_data
            const properties = feature.properties
            let custom_column = {} //not in properties
            let popup_data = {}

            if (api_data && api_data.data_time) {
                // add api_data.data_time to table
                custom_column = { API_DATA_TIME: api_data.data_time }
            }

            $.each(this.options.popup, function(i, o) {
                let value = '---'
                if (o.column[0] && o.column[1]) {
                    value = properties[o.column[0]] || '---'
                    value += ' (' + (properties[o.column[1]] || '---') + ')'
                } else if (o.column[0]) {
                    value = properties[o.column[0]] || '---'
                }

                popup_data[o.name] = value + (o.unit ? ' ' + o.unit : '')
            })

            return popup_data
        },
        get_wmarker_class: function() {
            let wm_class = ''
            if (this.has_jump_ctrl) {
                let zoom_ctrl_class = this.normal_zoom_class

                $.each(this.options.zoom_ctrl.jump, (zoom_level_class, jump_count) => {
                    if (this.count % jump_count === 1) {
                        zoom_ctrl_class = zoom_level_class
                        return false
                    }
                })
                wm_class += 'zoom-level ' + zoom_ctrl_class
            }

            return wm_class
        },
        change_color: function(color, ID) {
            this.pane.wmarker_builder.setWindbarColor(color, ID)
        },
        set_scale: function(scale_val) {
            if (!scale_val) {
                return
            }

            this.pane.wmarker_builder.setMarkerScale(scale_val)
        },
    },
    watch: {
        show_name: function(status) {
            // 顯示站名(true) | 隱藏站名(false)
            this.pane.wmarker_builder.displayName(status)
        },
        show_params: function(status) {
            // 顯示參數(true) | 隱藏參數(false)
            this.pane.wmarker_builder.displayBlockText(status)
        },
    },
    destroyed: function() {
        $(this.pane.$el)
            .find('.' + this.pane.wmarker_builder._markerClass)
            .parent()
            .remove()
    },
}
</script>

<style lang="css">
    .gis-btn {
        margin: 5px;
        padding: 5px 10px;
        font-size: 12px;
    }
</style>
